module.exports = __webpack_public_path__ + "static/media/sa.0831b1c1.svg";